module.exports = __webpack_public_path__ + "static/media/json.9091035b.svg";